import { useEmployeeAttendanceAuth } from './EmployeeAttendanceAuthContext';

/**
 * Shared officer session (HR + Admission) — same Bearer from /hr/login.
 * Kept as a thin shim for HR / Admission pages that expect ensureHrToken.
 */
export function useEmployeeAttendanceHrAuth() {
  const auth = useEmployeeAttendanceAuth();
  const isOfficer = Boolean(auth.isHr || auth.isAdmission || auth.isExam);
  return {
    user: isOfficer
      ? {
          name: auth.user?.name,
          email: auth.user?.email,
          portal_employee_count: auth.user?.portal_employee_count,
          is_hr: auth.isHr,
          is_admission: auth.isAdmission,
          is_exam: auth.isExam,
        }
      : null,
    loading: auth.loading,
    error: null,
    isAuthenticated: isOfficer,
    getToken: auth.getHrToken,
    ensureHrToken: auth.ensureHrToken,
    clearError: () => {},
  };
}

export function EmployeeAttendanceHrAuthProvider({ children }) {
  return children;
}

export default useEmployeeAttendanceHrAuth;
